<div class="container">
  <div class="row justify-content-center">
    <div class="col-24 col-m-16 col-l-12 d-flex align-items-end justify-content-center">
      <div class="c__icons">
        @for (picto of pictos; track picto) {
          <!-- <sd-banner *ngIf="pictos" [media]="picto"></sd-banner> -->
        }
      </div>
      <sd-html innerClass="is-caption" [html]="legalNotice" />
    </div>
  </div>
</div>
